<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">审批</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>部落资料审批</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content">
    <div class="actions-bar">
      <el-input
        placeholder="请输入部落名称"
        clearable
        v-model="tribeName"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button
        type="primary"
        @click="handleSearch"
      >搜索</el-button>
    </div>
    <audit-list @refresh="refreshList($event)"></audit-list>
  </el-card>
</div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import AuditList from './components/list';
import { PAGINATION } from './constants';

export default {
  name: 'tribe',
  data() {
    return {
      tribeName: null
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('tribeAudit', ['activeTab', 'pagination'])
  },
  methods: {
    ...mapActions('tribeAudit', ['list']),
    handleSearch() {
      this.list({
        tribeName: this.tribeName,
        ...PAGINATION
      });
    },
    refreshList(data = {}) {
      this.list({
        tribeName: this.tribeName,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.list({ page: 1, size: 25 });
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  .el-input {
    width: 300px;
    margin-right: 10px;
  }
}
</style>
